import { render } from "./Multiautocomplete.vue?vue&type=template&id=087020b7&scoped=true"
import script from "./Multiautocomplete.vue?vue&type=script&lang=js"
export * from "./Multiautocomplete.vue?vue&type=script&lang=js"

import "./Multiautocomplete.vue?vue&type=style&index=0&id=087020b7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087020b7"]])

export default __exports__